import * as React from 'react';

import { L10n } from '../../../common/utils/L10n';
import { SearchResultItem } from '../../models/SearchResultTypes';
import { CardViewStyles } from './CardViewStyles';
import { classNames } from '../../../../homepage/Utils';
import * as Layout from '../../../common/styles/Layout';

export interface GenericCardProps {
  content: SearchResultItem;
}

export function GenericCard(props: GenericCardProps): React.ReactElement<GenericCardProps> {
  return (
    <div className={classNames(Layout.relative, CardViewStyles.Card)}>
      <div className={CardViewStyles.Thumbnail}>
        <span>{L10n.elideIfLong(props.content.id)}</span>
      </div>
      <div className={CardViewStyles.ActionRow}>
        <span className={CardViewStyles.ActionRowName} title={L10n.elideIfLong(props.content.name)}>
          {L10n.elideIfLong(props.content.name)}
        </span>
      </div>
    </div>
  );
}
